// @flow
import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

const messages: { [key: string]: MessageDescriptor } = defineMessages({
  disabledFormMessage: {
    id: 'boxFileRequest.disabledForm.message',
    description: 'Message for disabled/deleted forms',
    defaultMessage:
      'This page is unavailable or no longer accepting submissions.',
  },
});

export default messages;
